import React from 'react';
import { StyleSheet, View } from 'react-native';
import { getColors } from '../../../../../constants/colors';
import { textStyles } from '../../../../../constants/textStyles';
import { mbTextStyles } from '@mightybyte/rnw.utils.style-utils';
import { Text } from 'react-native';
import { titleCase } from './utils/titleCase';
import { formatNumber } from './utils/formatNumber';
import { formatAge } from './utils/formatAge';

const COLORS = getColors();
type Ages = 'lateTeens' | '20s' | '30s' | '40s' | '50s+';
type AgeStats = Record<Ages, number>;

interface Props {
    identity: string;
    ageGroupHash: AgeStats;
    highestNumber: number;
    total: string;
}

export function IdentityCard({
    identity,
    ageGroupHash,
    highestNumber,
    total,
}: Props) {
    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <Text style={styles.identityText}>{titleCase(identity)}</Text>

                <Text style={styles.total}>Total: {total}</Text>
            </View>
            {Object.entries(ageGroupHash).map(([age, number]) => {
                return (
                    <View
                        style={[
                            styles.bar,
                            { width: `${(number / highestNumber) * 100}%` },
                        ]}
                    >
                        <Text style={styles.age}>{formatAge(age as Ages)}</Text>
                        <Text style={styles.number}>
                            {formatNumber(number)}
                        </Text>
                    </View>
                );
            })}
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        width: '32%',
        backgroundColor: COLORS['white'],
        borderRadius: 10,
        padding: 10,
    },

    identityText: mbTextStyles([
        textStyles.normalText,
        {
            fontWeight: '600',
            color: '#313131',
            textAlign: 'left',
            fontSize: 22,
        },
    ]),

    header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginRight: 20,
        marginBottom: 15,
    },

    bar: {
        minWidth: '30%',
        backgroundColor: '#F35E2E38',
        position: 'relative',
        height: 35,
        marginVertical: 5,
        borderRadius: 8,
        flexDirection: 'row',
        paddingHorizontal: 5,
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    age: mbTextStyles([
        textStyles.normalText,
        {
            fontWeight: '600',
            color: '#313131',

            fontSize: 14,
        },
    ]),

    total: mbTextStyles([
        textStyles.normalText,
        {
            fontWeight: '600',
            color: '#A6A5A5',

            fontSize: 18,
        },
    ]),
    number: mbTextStyles([
        textStyles.normalText,
        {
            fontWeight: '600',
            color: '#313131',

            fontSize: 14,
        },
    ]),
});
